import { render, staticRenderFns } from "./document-list.vue?vue&type=template&id=6f4a4f04&scoped=true"
import script from "./document-list.vue?vue&type=script&lang=js"
export * from "./document-list.vue?vue&type=script&lang=js"
import style0 from "./document-list.vue?vue&type=style&index=0&id=6f4a4f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a4f04",
  null
  
)

export default component.exports